const ButtonInline = ({ label, onClick }) => {
  const handleKeyUp = (e) => {
    if (e.key && e.key === "Enter") {
      onClick(e)
    }
  }
  return (
    <div
      onClick={onClick}
      className="pointer block select-none rounded-md border-2 border-solid border-teal-600 bg-white px-3 py-1 text-center font-bold transition-colors duration-200 hover:bg-teal-600 hover:text-white"
      onKeyUp={handleKeyUp}
      tabIndex="0"
      role="button"
    >
      {label}
    </div>
  )
}

export default ButtonInline
